import React from 'react';
import {
  Container,
  Typography,
  Box,
  AppBar,
  Toolbar,
  Button,
  Paper,
  IconButton,
} from '@mui/material';
import { QrCode2, ArrowBack, Home } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const TermsPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleHome = () => {
    navigate('/');
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f8fafc' }}>
              <AppBar position="static" color="primary" elevation={0} sx={{ bgcolor: '#1F425C' }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="back"
            onClick={handleBack}
            sx={{ mr: 2, color: '#fff' }}
          >
            <ArrowBack />
          </IconButton>
                      <img src="/HINDALCO.NS_BIG.png" alt="Hindalco" style={{ marginRight: '16px', height: '32px', width: 'auto' }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, color: '#fff', fontWeight: 500 }}>
            Terms of Service - Hindalco QR Management
          </Typography>
          <Button
            color="inherit"
            startIcon={<Home />}
            onClick={handleHome}
            sx={{
              ml: 2,
              color: '#fff',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            Home
          </Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ mt: 4, mb: 12, pb: 4 }}>
        <Paper elevation={2} sx={{
          p: { xs: 3, sm: 4, md: 6 },
          borderRadius: 3,
          bgcolor: '#fff',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
        }}>
          <Typography variant="h3" sx={{ 
            color: '#1F425C', 
            fontWeight: 600, 
            mb: 4,
            textAlign: 'center'
          }}>
            Terms of Service
          </Typography>

          <Typography variant="h6" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
            Last Updated: [Date to be added]
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Acceptance of Terms
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - Agreement to terms when using the QR Management system]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Service Description
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - Description of the QR code management services provided]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              User Responsibilities
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - User obligations and responsibilities when using the system]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Acceptable Use Policy
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - What constitutes acceptable use of the QR management platform]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Account Security
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - User account security requirements and responsibilities]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Intellectual Property
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - Intellectual property rights and usage restrictions]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Limitation of Liability
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - Liability limitations and disclaimers]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Termination
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - Conditions under which services may be terminated]
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              Changes to Terms
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7, color: '#555' }}>
              [Content to be added by admin - How and when terms may be updated]
            </Typography>
          </Box>

          <Box sx={{ 
            mt: 6, 
            p: 3, 
            bgcolor: '#f8f9fa', 
            borderRadius: 2,
            border: '1px dashed #dee2e6'
          }}>
            <Typography variant="h6" sx={{ color: '#1F425C', fontWeight: 600, mb: 2 }}>
              📝 Admin Note
            </Typography>
            <Typography variant="body2" sx={{ color: '#666', fontStyle: 'italic' }}>
              This is a template page. Please replace the placeholder content above with your actual terms of service. 
              Consider consulting with legal professionals to ensure compliance with applicable laws and adequate 
              protection for your QR management platform.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsPage; 